var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['app-container', _vm.$style.wrap]},[_c('div',{class:_vm.$style.title},[_c('p',[_vm._v("\n      极致游戏账号注销\n    ")])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }